import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useFamilyStore } from '@/store/familyStore';
import { MemberSearch } from '@/components/shared/search/MemberSearch';

interface AddChildFormData {
  childName: string;
  parentId: string;
  phoneNumber: string;
}

interface AddChildFormProps {
  formData: AddChildFormData;
  onChange: (data: AddChildFormData) => void;
  onSubmit: (e: React.FormEvent) => void;
  initialParentId?: string;
}

export function AddChildForm({
  formData,
  onChange,
  onSubmit,
  initialParentId,
}: AddChildFormProps) {
  const { members } = useFamilyStore();
  const selectedParent = members.find(m => m.id === formData.parentId);

  const handleChange = (field: keyof AddChildFormData, value: string) => {
    onChange({ ...formData, [field]: value });
  };

  return (
    <form onSubmit={onSubmit} className="space-y-8">
      <div className="space-y-6">
        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="childName">اسم المولود</Label>
            <Input
              id="childName"
              value={formData.childName || ''}
              onChange={(e) => handleChange('childName', e.target.value)}
              placeholder="أدخل اسم المولود"
              required
            />
          </div>

          <div className="space-y-2">
            <Label>الأب</Label>
            <MemberSearch
              onSelect={(memberId) => handleChange('parentId', memberId)}
              placeholder="ابحث عن الأب..."
              className="w-full"
            />
            {/* {selectedParent && (
              <div className="mt-2 p-3 bg-gray-50 rounded-lg">
                <div className="font-medium">الأب المحدد:</div>
                <div className="text-sm text-gray-600">{selectedParent.name}</div>
              </div>
            )} */}
          </div>

          <div className="space-y-2">
            <Label htmlFor="phoneNumber">رقم الجوال</Label>
            <Input
              id="phoneNumber"
              type="tel"
              dir="ltr"
              className="text-left"
              value={formData.phoneNumber || ''}
              onChange={(e) => handleChange('phoneNumber', e.target.value)}
              placeholder="05xxxxxxxx"
              required
            />
          </div>
        </div>
      </div>

      <Button
        type="submit"
        className="w-full hover:bg-secondary"
        disabled={!formData.childName || !formData.phoneNumber || !formData.parentId}
      >
        إرسال الطلب
      </Button>
    </form>
  );
}